import { useSignInWithStartPageData } from './resources/hooks';

const Page = () => {
    useSignInWithStartPageData();

    return null;
};

Page.displayName = 'Page';

export default Page;
